<template lang="pug">
  transition(@enter="enter", @leave="leave", v-bind:css="false")
    .p_modal(v-show="$store.state.modal.show", @click="closeTheModal", :class="$route.query.type === 'comics' ? 'c_col-c' : ''")
      the-modal-of-the-gallery(:array="array")
</template>

<script>
  import { TweenMax } from 'gsap'
  import TheModalOfTheGallery from '@/components/TheModalOfTheGallery.vue'
  export default {
    data () {
      return {
        baseUrl: false,
        current: {},
        currentId: 0,
        addClass: '',
        transform: false,
        array: [],
        id: Number,
      }
    },
    components: {
      TheModalOfTheGallery,
    },
    watch: {
      '$route.query': function () {
        this.id = Number(this.$route.query.id)
        this.createArray()

        if (Object.keys(this.$route.query).length === 0 && this.$store.state.modal.show) {
          this.leave(this.$el)
        } else {
          this.enter(this.$el)
        }
      },
      '$store.state.isLoading': function () {
        if (this.$store.state.modal.show && !this.$store.state.isLoading) {
          document.querySelector('html').classList.add('overflow')
        }
      }
    },
    mounted () {
      if (this.$store.state.modal.show) {
        this.enter(this.$el)
        document.querySelector('html').classList.add('overflow')
        this.createArray()
      }
      this.baseUrl = process.env.baseURL
    },
    methods: {
      createArray () {
        let num = this.$store.state.gallery.length
        let array = [...Array(num).keys()].map(i => ++i)

        this.id = Number(this.$route.query.id)

        let currentPos = array.indexOf(this.id)
        let spliceArray = array.splice(0,currentPos)
        let resultArray = array.concat(spliceArray)
        this.array = resultArray
      },
      enter (el, done) {
        if (this.$store.state.modal.show) {
          document.querySelector('html').classList.add('overflow')
          this.$nextTick(() => {
            TweenMax.to(el, .3, {
              autoAlpha: 1,
              ease: Power1.easeOut,
            })
          })
        }
      },
      leave (el, done) {
        let self = this
        this.closeTheModal()
        TweenMax.to(el, .6, {
          opacity: 0,
          ease: Power1.ease,
          onComplete () {
            el.scrollTop = 0
            self.transform = false
            TweenMax.to(el, .6, {
              autoAlpha: 0
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .p_modal {
    @include sp {
      padding: rem(130/2) 0;
    }
    width: 100%;
    min-height: 100%;
    background: rgba($palet2, .9);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    opacity: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    &-inner {
      @include pc {
        width: 100%;
        min-width: $min_l#{px};
        min-height: 100%;
        margin: rem(160) 0;
        position: relative;
      }
      @include sp {
        // min-height: vw(2242,750);
        margin: rem(20) 0 0;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TheModal.vue